import { Layout, Page, usePath } from "@fdoh/health-ui-react";
import { useData } from "../../hooks";
import { useHistory,useLocation, useParams } from "react-router-dom";
import TankInstallationForm from "../Components/TankInstallationForm";
import { TankInstallationInput } from "../Components/TankInstallationForm.types";
import ApplicationDetailsPage from "../Components/Home/ApplicationDetails";


// TODO: Add error handling



const EditTankInstallationPage = () => {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
    const applicationId = JSON.parse(searchParams.get("applicationId") || '{}');
    const inspectionId = JSON.parse(searchParams.get("inspectionId") || '{}');

    const path = usePath();
    const data = useData<TankInstallationInput>(path.current);
  return data && applicationId ? (
      <Page.Container>
          <ApplicationDetailsPage id={applicationId}></ApplicationDetailsPage>      
      <Page.Body>
        <Layout.Container>
           <TankInstallationForm
                      id="editTankInstallationForm"
                      title="Tank Installation Inspection"
            action="post"
                      applicationInspectionId={data?.applicationInspectionId}
                      applicationId={applicationId}
                      returnPath={`/inspectionDetails/${inspectionId}`}
            values={data}
          />
        </Layout.Container>
      </Page.Body>
    </Page.Container>
  ): <Page.Container>
  <Page.Header preTitle="Private Provider Inspection" title="Welcome" />
  <Page.Body>
      <Layout.Container>
          <div className="row row-dec row-cards">
              <div className="col-lg-12">
               
              </div>
          </div>
      </Layout.Container>
  </Page.Body>
</Page.Container>;
};

export default EditTankInstallationPage;